import { createFileRoute, Link } from "@tanstack/react-router";
import { feedQueryOptions } from "../queries/deals";
import { Feed } from "../components/feed";

export const Route = createFileRoute("/category/$slug")({
  loader: ({ context, params }) => {
    void context.queryClient.prefetchInfiniteQuery(
      feedQueryOptions({ sort: "hot", category: params.slug }),
    );
  },
  component: CategoryPage,
});

function CategoryPage() {
  const { slug } = Route.useParams();
  return (
    <main className="mx-auto w-full max-w-3xl px-4 sm:px-5 py-6 sm:py-8 flex-1">
      <p className="text-xs text-[color:var(--color-fg-muted)] mb-2">
        <Link to="/" className="hover:underline">← back</Link>
      </p>
      <h1 className="text-xl font-semibold tracking-tight mb-4">Category: {slug}</h1>
      <Feed sort="hot" category={slug} />
    </main>
  );
}
